<script lang="ts">
  import { cn } from '@shared/utils';

  export let size: 'sm' | 'md' | 'lg' = 'md';
</script>

<button
  class="
      {cn(
    'text-default-900 group/btn bg-default-70/70 dark:bg-dark-500/60 dark:text-dark-900/85 dark:hover:text-dark-900/100 relative rounded-full opacity-100 drop-shadow backdrop-blur-2xl transition-[opacity,background] hover:bg-white group-hover:opacity-100',
    {
      'p-2.5': size === 'sm',
      'p-3': size === 'md',
    },
  )}
    "
  on:click
>
  <slot />
</button>
